import { useEffect, useState } from 'react';
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { getExternalSystemsList } from '../../services/exams/sessions/sessions.service';
import { useStyles } from './AddSession.styles';
import { useHistory } from 'react-router-dom';
import { IExternalSystem } from '../../models/session.types';

import { getErrorPageUrl } from '../../utils/routerUrls';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import SelectItemsLoader from '../SelectItemsLoader.component';
import { ModalWithButtons } from '../ModalWithButtons/ModalWithButtons.component';

export interface SelectSystemProps {
  handleSelectSystem: (close: boolean, next: boolean, system: IExternalSystem | undefined) => void;
  handleLoader: (value: boolean) => void;
}

const SelectSystem = (props: SelectSystemProps) => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  const [saveDisable, setSaveDisable] = useState<boolean>(true);
  const [system, setSystem] = useState<IExternalSystem | undefined>(undefined);
  const [availableSystems, setAvailableSystems] = useState<IExternalSystem[]>([]);

  useEffect(() => {
    getExternalSystemsList()
      .then((result: IExternalSystem[]) => {
        setAvailableSystems(result);
      })
      .catch((error: AxiosError) => {
        history.push(getErrorPageUrl(error?.code ?? 500, 'admin'));
      });
  }, []);

  const closeHandle = () => {
    props.handleSelectSystem(true, false, undefined);
  };

  const handleNext = () => {
    props.handleSelectSystem(false, true, system);
  };

  const handleSystem = (e: any) => {
    setSystem(e.target.value);
    e.target.value ? setSaveDisable(false) : setSaveDisable(true);
  };

  return (
    <>
      <ModalWithButtons
        xCloseButton={closeHandle}
        open={true}
        size="lg"
        title={t('Nowa sesja egzaminacyjna')}
        confirmButtonLabel="Dalej"
        onConfirm={handleNext}
        confirmButtonDisabled={saveDisable}
        onCancel={closeHandle}
        handleClose={closeHandle}
        isHideBackdrop={true}
      >
        <Grid container justifyContent="center" alignItems="center">
          <div className={classes.numberCircleOutlineFirst}>
            <div className={classes.numbersInCirclesOutlineFirst}>
              <CheckIcon />
            </div>
          </div>
          <div className={classes.textOutline}>
            Dodaj nową sesję <br />
            egzaminacyjną
          </div>
          <hr className={classes.line}></hr>
          <div className={classes.numberCircleOutlineCheck}>
            <div className={classes.numbersInCirclesOutlineCheck}>
              <CheckIcon />
            </div>
          </div>
          <div className={classes.textOutline}>
            Import danych <br />
            sesji egzaminacyjnej
          </div>
          <hr className={classes.line}></hr>
          <div className={classes.numberCircleInline}>
            <div className={classes.numbersInCirclesInline}>3</div>
          </div>
          <div className={classes.textInline}>
            Wybierz system <br />
            źródłowy
          </div>
          <hr className={classes.line}></hr>
          <div className={classes.numberCircleOutline}>
            <div className={classes.numbersInCirclesOutline}>4</div>
          </div>
          <div className={classes.textOutline}>
            Wybierz sesję
            <br />
            egzaminacyjną i arkusz
          </div>
        </Grid>
        <Grid container justifyContent="center">
          <div className={classes.middleText}>Wybierz system źródłowy</div>
        </Grid>
        <Grid container justifyContent="center" style={{ marginBottom: '220px' }}>
          <FormControl variant="outlined" className={classes.formInput}>
            <InputLabel id="externalSystem-selector-label">System</InputLabel>
            <Select
              name={system?.name ?? ''}
              onChange={handleSystem}
              labelId="externalSystem-selector-label"
              id="externalSystem-selector"
              label="System"
              SelectDisplayProps={{
                style: {
                  padding: '15.5px',
                },
              }}
              defaultValue=""
            >
              {!availableSystems.length && <SelectItemsLoader />}
              {availableSystems.map((system: IExternalSystem, index: number) => (
                <MenuItem disableRipple className={classes.menuItem} key={index} value={system as any}>
                  {system.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </ModalWithButtons>
    </>
  );
};

export default SelectSystem;
